export const OffresDesktopFooter = () => {
  return (
    <div
      style={{
        WebkitBoxAlign: "stretch",
        alignItems: "stretch",
        backgroundImage:
          "linear-gradient(90deg, rgb(12, 19, 31) 50%, rgb(12, 19, 31) 50%)",
        width: "100%",
        boxSizing: "border-box",
        backgroundColor: "rgb(12, 19, 31)",
        minHeight: "100%",
        color: "rgb(243, 243, 244)",
        padding: "24px 0px",
      }}
      className="hidden xl:flex"
    >
      <div
        style={{
          maxWidth: "1440px",
          paddingLeft: "0px",
          paddingRight: "0px",
          boxSizing: "border-box",
          padding: "0px",
          width: "100%",
          marginLeft: "auto",
          marginRight: "auto",
          display: "block",
          height: "auto",
        }}
      >
        <div
          style={{
            boxSizing: "border-box",
            display: "flex",
            flexFlow: "row wrap",
            width: "100%",
            WebkitBoxPack: "center",
            justifyContent: "center",
            height: "1056px",
          }}
        >
          <div
            style={{
              paddingLeft: "80px",
              paddingRight: "80px",
              backgroundColor: "rgb(12, 19, 31)",
              flexBasis: "100%",
              WebkitBoxFlex: 0,
              flexGrow: 0,
              maxWidth: "100%",
              boxSizing: "border-box",
              margin: "0px",
              flexDirection: "row",
            }}
          >
            <div
              style={{
                display: "grid",
                gap: "24px",
                gridTemplateColumns: "296.016px 524.797px 411.188px",
                boxSizing: "border-box",
                margin: "24px 0px 16px",
              }}
            >
              <div style={{ marginTop: "0px", boxSizing: "border-box" }}>
                <p
                  style={{
                    fontSize: "16px",
                    lineHeight: "22px",
                    boxSizing: "border-box",
                    margin: "0px 0px 8px",
                    fontFamily: "Avenir",
                    fontWeight: 700,
                  }}
                >
                  Nos engagements
                </p>
                <ul
                  style={{
                    boxSizing: "border-box",
                    listStyle: "outside none none",
                    margin: "0px",
                    padding: "0px",
                  }}
                >
                  <li style={{ boxSizing: "border-box", marginBottom: "8px" }}>
                    <a
                      href="/tgv-inoui/tarifs"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Meilleurs prix garantis
                    </a>
                  </li>
                  <li style={{ boxSizing: "border-box", marginBottom: "8px" }}>
                    <a
                      href="/aide/le-paiement-securise-et-authentifie"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Paiement sécurisé
                    </a>
                  </li>
                  <li style={{ boxSizing: "border-box", marginBottom: "8px" }}>
                    <button
                      tabIndex={0}
                      role="link"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        appearance: "none",
                        textTransform: "none",
                        overflow: "visible",
                        fontFamily:
                          "Avenir",
                        margin: "0px",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(157, 160, 165) none 0px",
                        border: "0px none rgb(157, 160, 165)",
                        borderRadius: "0px",
                        userSelect: "none",
                        verticalAlign: "middle",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Contact 7j/7
                    </button>
                  </li>
                  <li style={{ boxSizing: "border-box" }}>
                    <a
                      href="/train/elu-service-client-annee"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Service client de l'année 2024
                    </a>
                  </li>
                </ul>
              </div>
              <div style={{ marginTop: "0px", boxSizing: "border-box" }}>
                <p
                  style={{
                    fontSize: "16px",
                    lineHeight: "22px",
                    boxSizing: "border-box",
                    margin: "0px 0px 8px",
                    fontFamily: "Avenir",
                    fontWeight: 700,
                  }}
                >
                  Moyens de paiement
                </p>
                <ul
                  style={{
                    boxSizing: "border-box",
                    listStyle: "outside none none",
                    margin: "0px",
                    display: "grid",
                    gap: "8px",
                    gridTemplateColumns: "repeat(auto-fill, 1.875rem)",
                    lineHeight: "0px",
                    padding: "8px 0px",
                  }}
                >
                  <li style={{ boxSizing: "border-box" }}>
                    <img
                      src="https://www.sncf-connect.com/assets/media/2021-11/cb.png"
                      alt="CB"
                      style={{
                        boxSizing: "border-box",
                        borderStyle: "none",
                        height: "30px",
                        width: "1.875rem",
                      }}
                    />
                  </li>
                  <li style={{ boxSizing: "border-box" }}>
                    <img
                      src="https://www.sncf-connect.com/assets/media/2021-11/visa.png"
                      alt="Visa"
                      style={{
                        boxSizing: "border-box",
                        borderStyle: "none",
                        height: "30px",
                        width: "1.875rem",
                      }}
                    />
                  </li>
                  <li style={{ boxSizing: "border-box" }}>
                    <img
                      src="https://www.sncf-connect.com/assets/media/2021-11/mastercard.png"
                      alt="Mastercard"
                      style={{
                        boxSizing: "border-box",
                        borderStyle: "none",
                        height: "30px",
                        width: "1.875rem",
                      }}
                    />
                  </li>
                  <li style={{ boxSizing: "border-box" }}>
                    <img
                      src="https://www.sncf-connect.com/assets/media/2021-11/amex.png"
                      alt="American Express"
                      style={{
                        boxSizing: "border-box",
                        borderStyle: "none",
                        height: "30px",
                        width: "1.875rem",
                      }}
                    />
                  </li>
                  <li style={{ boxSizing: "border-box" }}>
                    <img
                      src="https://www.sncf-connect.com/assets/media/2022-11/apple-pay.png"
                      alt="Apple Pay"
                      style={{
                        boxSizing: "border-box",
                        borderStyle: "none",
                        height: "30px",
                        width: "1.875rem",
                      }}
                    />
                  </li>
                  <li style={{ boxSizing: "border-box" }}>
                    <img
                      src="https://www.sncf-connect.com/assets/media/2022-05/ancv_0.png"
                      alt="ANCV"
                      style={{
                        boxSizing: "border-box",
                        borderStyle: "none",
                        height: "30px",
                        width: "1.875rem",
                      }}
                    />
                  </li>
                  <li style={{ boxSizing: "border-box" }}>
                    <img
                      src="https://www.sncf-connect.com/assets/media/2023-08/alma_logo.png"
                      alt="Alma"
                      style={{
                        boxSizing: "border-box",
                        borderStyle: "none",
                        height: "30px",
                        width: "1.875rem",
                      }}
                    />
                  </li>
                  <li style={{ boxSizing: "border-box" }}>
                    <button
                      role="link"
                      tabIndex={0}
                      title="Ayvens"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        appearance: "none",
                        textTransform: "none",
                        overflow: "visible",
                        fontFamily:
                          "Avenir",
                        margin: "0px",
                        fontWeight: 700,
                        color: "rgb(141, 232, 254)",
                        textDecoration: "none solid rgb(141, 232, 254)",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(141, 232, 254) none 0px",
                        border: "0px none rgb(141, 232, 254)",
                        borderRadius: "0px",
                        padding: "0px",
                        userSelect: "none",
                        verticalAlign: "middle",
                        cursor: "pointer",
                        position: "relative",
                        display: "inline-flex",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src="https://www.sncf-connect.com/assets/media/2024-05/logo-ayvens-light-format-footer.png"
                        alt="Ayvens"
                        style={{
                          boxSizing: "border-box",
                          borderStyle: "none",
                          height: "30px",
                          width: "1.875rem",
                        }}
                      />
                    </button>
                  </li>
                  <li style={{ boxSizing: "border-box" }}>
                    <button
                      role="link"
                      tabIndex={0}
                      title="Betterway"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        appearance: "none",
                        textTransform: "none",
                        overflow: "visible",
                        fontFamily:
                          "Avenir",
                        margin: "0px",
                        fontWeight: 700,
                        color: "rgb(141, 232, 254)",
                        textDecoration: "none solid rgb(141, 232, 254)",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(141, 232, 254) none 0px",
                        border: "0px none rgb(141, 232, 254)",
                        borderRadius: "0px",
                        padding: "0px",
                        userSelect: "none",
                        verticalAlign: "middle",
                        cursor: "pointer",
                        position: "relative",
                        display: "inline-flex",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src="https://www.sncf-connect.com/assets/media/2023-04/betterway.png"
                        alt="Betterway"
                        style={{
                          boxSizing: "border-box",
                          borderStyle: "none",
                          height: "30px",
                          width: "1.875rem",
                        }}
                      />
                    </button>
                  </li>
                  <li style={{ boxSizing: "border-box" }}>
                    <button
                      role="link"
                      tabIndex={0}
                      title="Pluxee"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        appearance: "none",
                        textTransform: "none",
                        overflow: "visible",
                        fontFamily:
                          "Avenir",
                        margin: "0px",
                        fontWeight: 700,
                        color: "rgb(141, 232, 254)",
                        textDecoration: "none solid rgb(141, 232, 254)",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(141, 232, 254) none 0px",
                        border: "0px none rgb(141, 232, 254)",
                        borderRadius: "0px",
                        padding: "0px",
                        userSelect: "none",
                        verticalAlign: "middle",
                        cursor: "pointer",
                        position: "relative",
                        display: "inline-flex",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src="https://www.sncf-connect.com/assets/media/2024-01/pluxee_0.png"
                        alt="Pluxee"
                        style={{
                          boxSizing: "border-box",
                          borderStyle: "none",
                          height: "30px",
                          width: "1.875rem",
                        }}
                      />
                    </button>
                  </li>
                  <li style={{ boxSizing: "border-box" }}>
                    <button
                      role="link"
                      tabIndex={0}
                      title="RoadMate"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        appearance: "none",
                        textTransform: "none",
                        overflow: "visible",
                        fontFamily:
                          "Avenir",
                        margin: "0px",
                        fontWeight: 700,
                        color: "rgb(141, 232, 254)",
                        textDecoration: "none solid rgb(141, 232, 254)",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(141, 232, 254) none 0px",
                        border: "0px none rgb(141, 232, 254)",
                        borderRadius: "0px",
                        padding: "0px",
                        userSelect: "none",
                        verticalAlign: "middle",
                        cursor: "pointer",
                        position: "relative",
                        display: "inline-flex",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src="https://www.sncf-connect.com/assets/media/2023-04/roadmate_0.png"
                        alt="RoadMate"
                        style={{
                          boxSizing: "border-box",
                          borderStyle: "none",
                          height: "30px",
                          width: "1.875rem",
                        }}
                      />
                    </button>
                  </li>
                  <li style={{ boxSizing: "border-box" }}>
                    <button
                      role="link"
                      tabIndex={0}
                      title="Swile"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        appearance: "none",
                        textTransform: "none",
                        overflow: "visible",
                        fontFamily:
                          "Avenir",
                        margin: "0px",
                        fontWeight: 700,
                        color: "rgb(141, 232, 254)",
                        textDecoration: "none solid rgb(141, 232, 254)",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(141, 232, 254) none 0px",
                        border: "0px none rgb(141, 232, 254)",
                        borderRadius: "0px",
                        padding: "0px",
                        userSelect: "none",
                        verticalAlign: "middle",
                        cursor: "pointer",
                        position: "relative",
                        display: "inline-flex",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src="https://www.sncf-connect.com/assets/media/2022-11/swile.png"
                        alt="Swile"
                        style={{
                          boxSizing: "border-box",
                          borderStyle: "none",
                          height: "30px",
                          width: "1.875rem",
                        }}
                      />
                    </button>
                  </li>
                  <li style={{ boxSizing: "border-box" }}>
                    <button
                      role="link"
                      tabIndex={0}
                      title="Worklife"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        appearance: "none",
                        textTransform: "none",
                        overflow: "visible",
                        fontFamily:
                          "Avenir",
                        margin: "0px",
                        fontWeight: 700,
                        color: "rgb(141, 232, 254)",
                        textDecoration: "none solid rgb(141, 232, 254)",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(141, 232, 254) none 0px",
                        border: "0px none rgb(141, 232, 254)",
                        borderRadius: "0px",
                        padding: "0px",
                        userSelect: "none",
                        verticalAlign: "middle",
                        cursor: "pointer",
                        position: "relative",
                        display: "inline-flex",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src="https://www.sncf-connect.com/assets/media/2023-03/worklife.png"
                        alt="Worklife"
                        style={{
                          boxSizing: "border-box",
                          borderStyle: "none",
                          height: "30px",
                          width: "1.875rem",
                        }}
                      />
                    </button>
                  </li>
                </ul>
                <ul
                  role="list"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "outside none none",
                    margin: "24px 0px 0px",
                    padding: "0px",
                  }}
                >
                  <li style={{ boxSizing: "border-box", marginBottom: "8px" }}>
                    <a
                      href="/aide/le-paiement-de-vos-billets-de-train-modes-de-paiement-acceptes"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Infos et conditions
                    </a>
                  </li>
                  <li style={{ boxSizing: "border-box", marginBottom: "8px" }}>
                    <a
                      href="/cheque-vacances-connect"
                      target="_blank"
                      title="Paiement en Chèque-Vacances Connect - Nouvel Onglet"
                      rel="noopener noreferrer"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Paiement en Chèque-Vacances Connect
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          boxSizing: "border-box",
                          height: "16px",
                          width: "1rem",
                          alignSelf: "normal",
                          fill: "rgb(157, 160, 165)",
                          flexShrink: 0,
                          marginLeft: "6px",
                        }}
                      >
                        <path
                          d="M19.7789 12.5524V18.6564C19.778 19.2739 19.5322 19.8658 19.0955 20.3024C18.6587 20.7389 18.0667 20.9844 17.4492 20.985H5.3297C4.71219 20.9844 4.12012 20.7389 3.68338 20.3024C3.24663 19.8658 3.00087 19.2739 3 18.6564V6.44946C3.00064 5.83178 3.24629 5.23958 3.68306 4.80282C4.11982 4.36605 4.71202 4.1204 5.3297 4.11976H11.2589C11.3472 4.11942 11.4347 4.13652 11.5164 4.17009C11.5981 4.20365 11.6724 4.25302 11.735 4.31535C11.7975 4.37769 11.8472 4.45177 11.8811 4.53334C11.915 4.61491 11.9324 4.70237 11.9324 4.79069C11.9324 4.87902 11.915 4.96648 11.8811 5.04805C11.8472 5.12962 11.7975 5.2037 11.735 5.26604C11.6724 5.32837 11.5981 5.37774 11.5164 5.4113C11.4347 5.44487 11.3472 5.46197 11.2589 5.46163H5.3297C5.06797 5.46214 4.81712 5.56642 4.63215 5.75159C4.44719 5.93677 4.34319 6.18773 4.34297 6.44946V18.6564C4.34323 18.918 4.44728 19.1688 4.63227 19.3538C4.81726 19.5388 5.06808 19.6428 5.3297 19.6431H17.4492C17.7108 19.6428 17.9616 19.5388 18.1466 19.3538C18.3316 19.1688 18.4356 18.918 18.4359 18.6564V12.5524C18.4359 12.3743 18.5067 12.2035 18.6326 12.0775C18.7585 11.9516 18.9293 11.8808 19.1074 11.8808C19.2855 11.8808 19.4563 11.9516 19.5822 12.0775C19.7082 12.2035 19.7789 12.3743 19.7789 12.5524L19.7789 12.5524ZM20.9482 3.42936C20.8971 3.30702 20.811 3.20247 20.7008 3.12878C20.5906 3.05508 20.4611 3.01551 20.3285 3.01502H15.3287C15.2404 3.01468 15.1529 3.03178 15.0712 3.06535C14.9895 3.09891 14.9152 3.14828 14.8526 3.21061C14.7901 3.27295 14.7404 3.34703 14.7065 3.4286C14.6726 3.51017 14.6552 3.59763 14.6552 3.68595C14.6552 3.77428 14.6726 3.86174 14.7065 3.94331C14.7404 4.02488 14.7901 4.09896 14.8526 4.1613C14.9152 4.22363 14.9895 4.273 15.0712 4.30656C15.1529 4.34013 15.2404 4.35723 15.3287 4.35689H18.7085L11.5544 11.511C11.429 11.637 11.3587 11.8076 11.3589 11.9854C11.3591 12.1632 11.4299 12.3336 11.5557 12.4593C11.6815 12.5849 11.852 12.6555 12.0298 12.6556C12.2076 12.6556 12.3782 12.5851 12.504 12.4595L19.657 5.30648V8.68628C19.657 8.86437 19.7278 9.03517 19.8537 9.1611C19.9796 9.28703 20.1504 9.35778 20.3285 9.35778C20.5066 9.35778 20.6774 9.28703 20.8033 9.1611C20.9293 9.03517 21 8.86437 21 8.68628V3.68598C20.9998 3.59786 20.9821 3.51066 20.9482 3.42935V3.42936Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                    </a>
                  </li>
                  <li style={{ boxSizing: "border-box" }}>
                    <a
                      href="/train/bons-plans/budget-mobilite?prex=homepage_footer"
                      target="_blank"
                      title="Infos et conditions de paiement avec les cartes Ayvens, Betterway, Pluxee, RoadMate, Swile ou Worklife - Nouvel Onglet"
                      rel="noopener noreferrer"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Infos et conditions de paiement avec les cartes Ayvens,
                      Betterway, Pluxee, RoadMate, Swile ou Worklife
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          boxSizing: "border-box",
                          height: "16px",
                          width: "1rem",
                          alignSelf: "normal",
                          fill: "rgb(157, 160, 165)",
                          flexShrink: 0,
                          marginLeft: "6px",
                        }}
                      >
                        <path
                          d="M19.7789 12.5524V18.6564C19.778 19.2739 19.5322 19.8658 19.0955 20.3024C18.6587 20.7389 18.0667 20.9844 17.4492 20.985H5.3297C4.71219 20.9844 4.12012 20.7389 3.68338 20.3024C3.24663 19.8658 3.00087 19.2739 3 18.6564V6.44946C3.00064 5.83178 3.24629 5.23958 3.68306 4.80282C4.11982 4.36605 4.71202 4.1204 5.3297 4.11976H11.2589C11.3472 4.11942 11.4347 4.13652 11.5164 4.17009C11.5981 4.20365 11.6724 4.25302 11.735 4.31535C11.7975 4.37769 11.8472 4.45177 11.8811 4.53334C11.915 4.61491 11.9324 4.70237 11.9324 4.79069C11.9324 4.87902 11.915 4.96648 11.8811 5.04805C11.8472 5.12962 11.7975 5.2037 11.735 5.26604C11.6724 5.32837 11.5981 5.37774 11.5164 5.4113C11.4347 5.44487 11.3472 5.46197 11.2589 5.46163H5.3297C5.06797 5.46214 4.81712 5.56642 4.63215 5.75159C4.44719 5.93677 4.34319 6.18773 4.34297 6.44946V18.6564C4.34323 18.918 4.44728 19.1688 4.63227 19.3538C4.81726 19.5388 5.06808 19.6428 5.3297 19.6431H17.4492C17.7108 19.6428 17.9616 19.5388 18.1466 19.3538C18.3316 19.1688 18.4356 18.918 18.4359 18.6564V12.5524C18.4359 12.3743 18.5067 12.2035 18.6326 12.0775C18.7585 11.9516 18.9293 11.8808 19.1074 11.8808C19.2855 11.8808 19.4563 11.9516 19.5822 12.0775C19.7082 12.2035 19.7789 12.3743 19.7789 12.5524L19.7789 12.5524ZM20.9482 3.42936C20.8971 3.30702 20.811 3.20247 20.7008 3.12878C20.5906 3.05508 20.4611 3.01551 20.3285 3.01502H15.3287C15.2404 3.01468 15.1529 3.03178 15.0712 3.06535C14.9895 3.09891 14.9152 3.14828 14.8526 3.21061C14.7901 3.27295 14.7404 3.34703 14.7065 3.4286C14.6726 3.51017 14.6552 3.59763 14.6552 3.68595C14.6552 3.77428 14.6726 3.86174 14.7065 3.94331C14.7404 4.02488 14.7901 4.09896 14.8526 4.1613C14.9152 4.22363 14.9895 4.273 15.0712 4.30656C15.1529 4.34013 15.2404 4.35723 15.3287 4.35689H18.7085L11.5544 11.511C11.429 11.637 11.3587 11.8076 11.3589 11.9854C11.3591 12.1632 11.4299 12.3336 11.5557 12.4593C11.6815 12.5849 11.852 12.6555 12.0298 12.6556C12.2076 12.6556 12.3782 12.5851 12.504 12.4595L19.657 5.30648V8.68628C19.657 8.86437 19.7278 9.03517 19.8537 9.1611C19.9796 9.28703 20.1504 9.35778 20.3285 9.35778C20.5066 9.35778 20.6774 9.28703 20.8033 9.1611C20.9293 9.03517 21 8.86437 21 8.68628V3.68598C20.9998 3.59786 20.9821 3.51066 20.9482 3.42935V3.42936Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>
              <div style={{ marginTop: "0px", boxSizing: "border-box" }}>
                <p
                  style={{
                    fontSize: "16px",
                    lineHeight: "22px",
                    boxSizing: "border-box",
                    margin: "0px 0px 8px",
                    fontFamily: "Avenir",
                    fontWeight: 700,
                  }}
                >
                  Choix du pays
                </p>
                <div
                  style={{
                    boxSizing: "border-box",
                    maxWidth: "410px",
                    padding: "8px 0px",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      display: "inline-flex",
                      flexDirection: "column",
                      position: "relative",
                      minWidth: "0px",
                      padding: "0px",
                      margin: "0px",
                      border: "0px none rgb(243, 243, 244)",
                      verticalAlign: "top",
                      width: "100%",
                    }}
                  >
                    <label
                      data-shrink="true"
                      style={{
                        fontSize: "16px",
                        lineHeight: "22px",
                        boxSizing: "border-box",
                        color: "rgb(243, 243, 244)",
                        transform: "matrix(0.96, 0, 0, 0.96, 14, -6)",
                        padding: "0px",
                        display: "block",
                        transformOrigin: "0px 0px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "calc(133% - 24px)",
                        position: "absolute",
                        left: "0px",
                        top: "0px",
                        transition:
                          "color 0.2s cubic-bezier(0, 0, 0.2, 1) 0s, transform 0.2s cubic-bezier(0, 0, 0.2, 1) 0s, max-width 0.2s cubic-bezier(0, 0, 0.2, 1) 0s",
                        zIndex: 1,
                        pointerEvents: "auto",
                        userSelect: "none",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                      }}
                    >
                      <p
                        style={{
                          fontSize: "13px",
                          lineHeight: "18px",
                          boxSizing: "border-box",
                          margin: "0px",
                          fontFamily:
                            "Avenir",
                          fontWeight: 700,
                        }}
                      >
                        Langue
                      </p>
                    </label>
                    <div
                      style={{
                        boxSizing: "border-box",
                        fontFamily:
                          "Avenir",
                        fontWeight: 400,
                        fontSize: "16px",
                        lineHeight: "23px",
                        color: "rgb(243, 243, 244)",
                        cursor: "text",
                        display: "flex",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        position: "relative",
                        borderRadius: "8px",
                        maxHeight: "56px",
                      }}
                    >
                      <div
                        tabIndex={0}
                        role="button"
                        aria-expanded="false"
                        aria-haspopup="listbox"
                        aria-labelledby="footer-language-selector-label footer-language-selector"
                        style={{
                          fontSize: "16px",
                          lineHeight: "22px",
                          boxSizing: "content-box",
                          height: "auto",
                          minHeight: "23px",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          paddingRight: "32px",
                          appearance: "none",
                          userSelect: "none",
                          borderRadius: "14px",
                          cursor: "pointer",
                          fontStyle: "normal",
                          fontVariant: "normal",
                          fontStretch: "100%",
                          fontOpticalSizing: "auto",
                          fontKerning: "auto",
                          fontFeatureSettings: "normal",
                          fontVariationSettings: "normal",
                          letterSpacing: "normal",
                          color: "rgb(243, 243, 244)",
                          border: "0px none rgb(243, 243, 244)",
                          margin: "0px",
                          WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                          display: "block",
                          minWidth: "0px",
                          width: "100%",
                          animationName: "mui-auto-fill-cancel",
                          animationDuration: "0.01s",
                          padding: "16.5px 32px 16.5px 14px",
                          fontFamily:
                            "Avenir",
                          fontWeight: 700,
                        }}
                      >
                        <div
                          style={{
                            boxSizing: "content-box",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "flex",
                          }}
                        >
                          <img
                            alt=""
                            src="https://www.sncf-connect.com/app/flag-icons/FR.svg"
                            style={{
                              boxSizing: "content-box",
                              borderStyle: "none",
                              borderRadius: "2px",
                              height: "14px",
                              width: "1.25rem",
                            }}
                          />
                          <p
                            style={{
                              fontSize: "16px",
                              lineHeight: "22px",
                              boxSizing: "content-box",
                              marginLeft: "10px",
                              margin: "0px 0px 0px 10px",
                              fontFamily:
                                "Avenir",
                              fontWeight: 700,
                            }}
                          >
                            France
                          </p>
                        </div>
                      </div>
                      <input
                        aria-hidden="true"
                        tabIndex={-1}
                        value="fr-fr"
                        style={{
                          boxSizing: "border-box",
                          overflow: "visible",
                          fontFamily:
                            "Avenir",
                          fontSize: "16px",
                          lineHeight: "18.4px",
                          margin: "0px",
                          bottom: "0px",
                          left: "0px",
                          position: "absolute",
                          opacity: 0,
                          pointerEvents: "none",
                          width: "100%",
                        }}
                      />
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          boxSizing: "border-box",
                          position: "absolute",
                          right: "7px",
                          top: "16px",
                          pointerEvents: "none",
                          color: "rgb(243, 243, 244)",
                          fill: "rgb(141, 232, 254)",
                          width: "1.5rem",
                        }}
                      >
                        <path
                          d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                      <fieldset
                        aria-hidden="true"
                        style={{
                          boxSizing: "border-box",
                          padding: "0px 8px",
                          textAlign: "left",
                          position: "absolute",
                          inset: "-5px 0px 0px",
                          margin: "0px",
                          pointerEvents: "none",
                          borderRadius: "8px",
                          borderStyle: "solid",
                          borderWidth: "1px",
                          overflow: "hidden",
                          minWidth: "0%",
                          borderColor: "rgb(165, 172, 188)",
                          border: "1px solid rgb(165, 172, 188)",
                        }}
                      >
                        <legend
                          style={{
                            boxSizing: "border-box",
                            color: "rgb(243, 243, 244)",
                            display: "block",
                            maxWidth: "100%",
                            padding: "0px",
                            whiteSpace: "nowrap",
                            float: "none",
                            width: "auto",
                            overflow: "hidden",
                            height: "11px",
                            fontSize: "12px",
                            visibility: "hidden",
                            transition:
                              "max-width 0.1s cubic-bezier(0, 0, 0.2, 1) 0.05s",
                          }}
                        >
                          <span
                            style={{
                              boxSizing: "border-box",
                              paddingLeft: "5px",
                              paddingRight: "5px",
                              display: "inline-block",
                              opacity: 0,
                              visibility: "visible",
                            }}
                          >
                            Langue
                          </span>
                        </legend>
                      </fieldset>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr
              aria-hidden="true"
              style={{
                boxSizing: "content-box",
                height: "2px",
                overflow: "visible",
                margin: "0px",
                flexShrink: 0,
                borderWidth: "0px",
                borderColor: "rgb(173, 255, 47)",
                backgroundColor: "rgb(36, 43, 53)",
                borderStyle: "none",
              }}
            />
            <div
              style={{
                display: "grid",
                gap: "24px",
                gridTemplateColumns: "296.016px 524.797px 411.188px",
                boxSizing: "border-box",
                margin: "24px 0px 16px",
              }}
            >
              <div style={{ boxSizing: "border-box" }}>
                <p
                  style={{
                    fontSize: "16px",
                    lineHeight: "22px",
                    boxSizing: "border-box",
                    margin: "0px 0px 8px",
                    fontFamily: "Avenir",
                    fontWeight: 700,
                  }}
                >
                  Nos partenaires
                </p>
                <ul
                  style={{
                    boxSizing: "border-box",
                    listStyle: "outside none none",
                    margin: "0px",
                    padding: "0px",
                    display: "flex",
                    flexWrap: "wrap",
                    maxWidth: "calc(100% - 8px)",
                  }}
                >
                  <li style={{ boxSizing: "border-box" }}>
                    <a
                      href="/train/services-train/assurance-allianz-travel"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        color: "rgb(141, 232, 254)",
                        textDecoration: "none solid rgb(141, 232, 254)",
                        cursor: "pointer",
                        position: "relative",
                        display: "inline-flex",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      <img
                        src="https://www.sncf-connect.com/assets/media/2021-11/allianz_eagle_travel_50x150_pixels_negative_footer.png"
                        alt="Allianz Travel"
                        style={{
                          boxSizing: "border-box",
                          borderStyle: "none",
                          height: "36px",
                        }}
                      />
                    </a>
                  </li>
                  <li style={{ boxSizing: "border-box", marginLeft: "24px" }}>
                    <a
                      href="http://www.railteam.fr"
                      target="_blank"
                      title="Railteam - Nouvel Onglet"
                      rel="noopener noreferrer"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        color: "rgb(141, 232, 254)",
                        textDecoration: "none solid rgb(141, 232, 254)",
                        cursor: "pointer",
                        position: "relative",
                        display: "inline-flex",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      <img
                        src="https://www.sncf-connect.com/assets/media/2021-11/railteam.png"
                        alt="Railteam"
                        style={{
                          boxSizing: "border-box",
                          borderStyle: "none",
                          height: "36px",
                        }}
                      />
                    </a>
                  </li>
                </ul>
              </div>
              <div style={{ marginTop: "0px", boxSizing: "border-box" }}>
                <p
                  style={{
                    fontSize: "16px",
                    lineHeight: "22px",
                    boxSizing: "border-box",
                    margin: "0px 0px 8px",
                    fontFamily: "Avenir",
                    fontWeight: 700,
                  }}
                >
                  Suivez-nous !
                </p>
                <ul
                  role="list"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "outside none none",
                    margin: "0px",
                    padding: "0px",
                    display: "grid",
                    gap: "16px",
                    gridTemplateColumns: "repeat(auto-fill, 2rem)",
                  }}
                >
                  <li style={{ boxSizing: "border-box" }}>
                    <a
                      href="https://www.instagram.com/sncfconnect/"
                      target="_blank"
                      title="Instagram - Nouvel Onglet"
                      rel="noopener noreferrer"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        color: "rgb(141, 232, 254)",
                        textDecoration: "none solid rgb(141, 232, 254)",
                        cursor: "pointer",
                        position: "relative",
                        display: "inline-flex",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      <img
                        src="https://www.sncf-connect.com/assets/media/2022-01/instagram_outline_12.svg"
                        alt="Instagram"
                        style={{
                          boxSizing: "border-box",
                          borderStyle: "none",
                          height: "32px",
                          width: "2rem",
                        }}
                      />
                    </a>
                  </li>
                  <li style={{ boxSizing: "border-box" }}>
                    <a
                      href="https://www.tiktok.com/@sncfconnect"
                      target="_blank"
                      title="TikTok - Nouvel Onglet"
                      rel="noopener noreferrer"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        color: "rgb(141, 232, 254)",
                        textDecoration: "none solid rgb(141, 232, 254)",
                        cursor: "pointer",
                        position: "relative",
                        display: "inline-flex",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      <img
                        src="https://www.sncf-connect.com/assets/media/2022-01/tiktok_outline.svg"
                        alt="TikTok"
                        style={{
                          boxSizing: "border-box",
                          borderStyle: "none",
                          height: "32px",
                          width: "2rem",
                        }}
                      />
                    </a>
                  </li>
                  <li style={{ boxSizing: "border-box" }}>
                    <a
                      href="https://www.facebook.com/sncfconnect"
                      target="_blank"
                      title="Facebook - Nouvel Onglet"
                      rel="noopener noreferrer"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        color: "rgb(141, 232, 254)",
                        textDecoration: "none solid rgb(141, 232, 254)",
                        cursor: "pointer",
                        position: "relative",
                        display: "inline-flex",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      <img
                        src="https://www.sncf-connect.com/assets/media/2023-12/facebook_outline.svg"
                        alt="Facebook"
                        style={{
                          boxSizing: "border-box",
                          borderStyle: "none",
                          height: "32px",
                          width: "2rem",
                        }}
                      />
                    </a>
                  </li>
                  <li style={{ boxSizing: "border-box" }}>
                    <a
                      href="https://twitter.com/sncfconnect"
                      target="_blank"
                      title="X, anciennement Twitter - Nouvel Onglet"
                      rel="noopener noreferrer"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        color: "rgb(141, 232, 254)",
                        textDecoration: "none solid rgb(141, 232, 254)",
                        cursor: "pointer",
                        position: "relative",
                        display: "inline-flex",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      <img
                        src="https://www.sncf-connect.com/assets/media/2023-09/x_outline.svg"
                        alt="X, anciennement Twitter"
                        style={{
                          boxSizing: "border-box",
                          borderStyle: "none",
                          height: "32px",
                          width: "2rem",
                        }}
                      />
                    </a>
                  </li>
                  <li style={{ boxSizing: "border-box" }}>
                    <a
                      href="https://www.pinterest.fr/sncfconnect/"
                      target="_blank"
                      title="Pinterest - Nouvel Onglet"
                      rel="noopener noreferrer"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        color: "rgb(141, 232, 254)",
                        textDecoration: "none solid rgb(141, 232, 254)",
                        cursor: "pointer",
                        position: "relative",
                        display: "inline-flex",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      <img
                        src="https://www.sncf-connect.com/assets/media/2022-01/pinterest_outline_11.svg"
                        alt="Pinterest"
                        style={{
                          boxSizing: "border-box",
                          borderStyle: "none",
                          height: "32px",
                          width: "2rem",
                        }}
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <hr
              aria-hidden="true"
              style={{
                boxSizing: "content-box",
                height: "2px",
                overflow: "visible",
                margin: "0px",
                flexShrink: 0,
                borderWidth: "0px",
                borderColor: "rgb(173, 255, 47)",
                backgroundColor: "rgb(36, 43, 53)",
                borderStyle: "none",
              }}
            />
            <div
              style={{
                display: "grid",
                gap: "24px",
                gridTemplateColumns:
                  "236.797px 236.797px 236.797px 236.797px 236.812px",
                boxSizing: "border-box",
                margin: "24px 0px 16px",
              }}
            >
              <div style={{ marginTop: "0px", boxSizing: "border-box" }}>
                <p
                  style={{
                    fontSize: "16px",
                    lineHeight: "22px",
                    boxSizing: "border-box",
                    margin: "0px 0px 8px",
                    fontFamily: "Avenir",
                    fontWeight: 700,
                  }}
                >
                  L'entreprise
                </p>
                <ul
                  style={{
                    boxSizing: "border-box",
                    listStyle: "outside none none",
                    margin: "0px",
                    padding: "0px",
                  }}
                >
                  <li style={{ boxSizing: "border-box", marginBottom: "8px" }}>
                    <a
                      href="/conditions-generales-presentation-offres-agence"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Conditions de présentation des offres sur le site
                    </a>
                  </li>
                  <li style={{ boxSizing: "border-box", marginBottom: "8px" }}>
                    <button
                      tabIndex={0}
                      role="link"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        appearance: "none",
                        textTransform: "none",
                        overflow: "visible",
                        fontFamily:
                          "Avenir",
                        margin: "0px",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(157, 160, 165) none 0px",
                        border: "0px none rgb(157, 160, 165)",
                        borderRadius: "0px",
                        userSelect: "none",
                        verticalAlign: "middle",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Conditions générales de vente
                    </button>
                  </li>
                  <li style={{ boxSizing: "border-box", marginBottom: "8px" }}>
                    <a
                      href="/aide/droits-des-voyageurs-ferroviaires"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Droits des voyageurs ferroviaires et Règlement européen
                      n°2021/782
                    </a>
                  </li>
                  <li style={{ boxSizing: "border-box", marginBottom: "8px" }}>
                    <a
                      href="/informations-legales"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Informations légales
                    </a>
                  </li>
                  <li style={{ boxSizing: "border-box", marginBottom: "8px" }}>
                    <button
                      tabIndex={0}
                      role="link"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        appearance: "none",
                        textTransform: "none",
                        overflow: "visible",
                        fontFamily:
                          "Avenir",
                        margin: "0px",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(157, 160, 165) none 0px",
                        border: "0px none rgb(157, 160, 165)",
                        borderRadius: "0px",
                        userSelect: "none",
                        verticalAlign: "middle",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Charte de confidentialité et cookies
                    </button>
                  </li>
                  <li style={{ boxSizing: "border-box" }}>
                    <a
                      href="/app/account/consentManagement"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Gestion des cookies
                    </a>
                  </li>
                </ul>
              </div>
              <div style={{ marginTop: "0px", boxSizing: "border-box" }}>
                <p
                  style={{
                    fontSize: "16px",
                    lineHeight: "22px",
                    boxSizing: "border-box",
                    margin: "0px 0px 8px",
                    fontFamily: "Avenir",
                    fontWeight: 700,
                  }}
                >
                  Partenariat
                </p>
                <ul
                  style={{
                    boxSizing: "border-box",
                    listStyle: "outside none none",
                    margin: "0px",
                    padding: "0px",
                  }}
                >
                  <li style={{ boxSizing: "border-box", marginBottom: "8px" }}>
                    <a
                      href="/outils/regie-ouiad"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Régie publicitaire
                    </a>
                  </li>
                  <li style={{ boxSizing: "border-box", marginBottom: "8px" }}>
                    <a
                      href="/outils/partenaire-affiliation"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Devenir partenaire ou affilié
                    </a>
                  </li>
                  <li style={{ boxSizing: "border-box" }}>
                    <button
                      tabIndex={0}
                      role="link"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        appearance: "none",
                        textTransform: "none",
                        overflow: "visible",
                        fontFamily:
                          "Avenir",
                        margin: "0px",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(157, 160, 165) none 0px",
                        border: "0px none rgb(157, 160, 165)",
                        borderRadius: "0px",
                        userSelect: "none",
                        verticalAlign: "middle",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Widget SNCF Connect
                    </button>
                  </li>
                </ul>
              </div>
              <div style={{ marginTop: "0px", boxSizing: "border-box" }}>
                <p
                  style={{
                    fontSize: "16px",
                    lineHeight: "22px",
                    boxSizing: "border-box",
                    margin: "0px 0px 8px",
                    fontFamily: "Avenir",
                    fontWeight: 700,
                  }}
                >
                  Sites du groupe
                </p>
                <ul
                  style={{
                    boxSizing: "border-box",
                    listStyle: "outside none none",
                    margin: "0px",
                    padding: "0px",
                  }}
                >
                  <li style={{ boxSizing: "border-box", marginBottom: "8px" }}>
                    <a
                      href="https://presse.vous.sncf-connect.com/"
                      target="_blank"
                      title="Espace Presse SNCF Connect &amp; Tech - Nouvel Onglet"
                      rel="noopener noreferrer"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Espace Presse SNCF Connect &amp; Tech
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          boxSizing: "border-box",
                          height: "16px",
                          width: "1rem",
                          alignSelf: "normal",
                          fill: "rgb(157, 160, 165)",
                          flexShrink: 0,
                          marginLeft: "6px",
                        }}
                      >
                        <path
                          d="M19.7789 12.5524V18.6564C19.778 19.2739 19.5322 19.8658 19.0955 20.3024C18.6587 20.7389 18.0667 20.9844 17.4492 20.985H5.3297C4.71219 20.9844 4.12012 20.7389 3.68338 20.3024C3.24663 19.8658 3.00087 19.2739 3 18.6564V6.44946C3.00064 5.83178 3.24629 5.23958 3.68306 4.80282C4.11982 4.36605 4.71202 4.1204 5.3297 4.11976H11.2589C11.3472 4.11942 11.4347 4.13652 11.5164 4.17009C11.5981 4.20365 11.6724 4.25302 11.735 4.31535C11.7975 4.37769 11.8472 4.45177 11.8811 4.53334C11.915 4.61491 11.9324 4.70237 11.9324 4.79069C11.9324 4.87902 11.915 4.96648 11.8811 5.04805C11.8472 5.12962 11.7975 5.2037 11.735 5.26604C11.6724 5.32837 11.5981 5.37774 11.5164 5.4113C11.4347 5.44487 11.3472 5.46197 11.2589 5.46163H5.3297C5.06797 5.46214 4.81712 5.56642 4.63215 5.75159C4.44719 5.93677 4.34319 6.18773 4.34297 6.44946V18.6564C4.34323 18.918 4.44728 19.1688 4.63227 19.3538C4.81726 19.5388 5.06808 19.6428 5.3297 19.6431H17.4492C17.7108 19.6428 17.9616 19.5388 18.1466 19.3538C18.3316 19.1688 18.4356 18.918 18.4359 18.6564V12.5524C18.4359 12.3743 18.5067 12.2035 18.6326 12.0775C18.7585 11.9516 18.9293 11.8808 19.1074 11.8808C19.2855 11.8808 19.4563 11.9516 19.5822 12.0775C19.7082 12.2035 19.7789 12.3743 19.7789 12.5524L19.7789 12.5524ZM20.9482 3.42936C20.8971 3.30702 20.811 3.20247 20.7008 3.12878C20.5906 3.05508 20.4611 3.01551 20.3285 3.01502H15.3287C15.2404 3.01468 15.1529 3.03178 15.0712 3.06535C14.9895 3.09891 14.9152 3.14828 14.8526 3.21061C14.7901 3.27295 14.7404 3.34703 14.7065 3.4286C14.6726 3.51017 14.6552 3.59763 14.6552 3.68595C14.6552 3.77428 14.6726 3.86174 14.7065 3.94331C14.7404 4.02488 14.7901 4.09896 14.8526 4.1613C14.9152 4.22363 14.9895 4.273 15.0712 4.30656C15.1529 4.34013 15.2404 4.35723 15.3287 4.35689H18.7085L11.5544 11.511C11.429 11.637 11.3587 11.8076 11.3589 11.9854C11.3591 12.1632 11.4299 12.3336 11.5557 12.4593C11.6815 12.5849 11.852 12.6555 12.0298 12.6556C12.2076 12.6556 12.3782 12.5851 12.504 12.4595L19.657 5.30648V8.68628C19.657 8.86437 19.7278 9.03517 19.8537 9.1611C19.9796 9.28703 20.1504 9.35778 20.3285 9.35778C20.5066 9.35778 20.6774 9.28703 20.8033 9.1611C20.9293 9.03517 21 8.86437 21 8.68628V3.68598C20.9998 3.59786 20.9821 3.51066 20.9482 3.42935V3.42936Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                    </a>
                  </li>
                  <li style={{ boxSizing: "border-box", marginBottom: "8px" }}>
                    <a
                      href="https://jobs.connect-tech.sncf/"
                      target="_blank"
                      title="Carrières SNCF Connect &amp; Tech - Nouvel Onglet"
                      rel="noopener noreferrer"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Carrières SNCF Connect &amp; Tech
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          boxSizing: "border-box",
                          height: "16px",
                          width: "1rem",
                          alignSelf: "normal",
                          fill: "rgb(157, 160, 165)",
                          flexShrink: 0,
                          marginLeft: "6px",
                        }}
                      >
                        <path
                          d="M19.7789 12.5524V18.6564C19.778 19.2739 19.5322 19.8658 19.0955 20.3024C18.6587 20.7389 18.0667 20.9844 17.4492 20.985H5.3297C4.71219 20.9844 4.12012 20.7389 3.68338 20.3024C3.24663 19.8658 3.00087 19.2739 3 18.6564V6.44946C3.00064 5.83178 3.24629 5.23958 3.68306 4.80282C4.11982 4.36605 4.71202 4.1204 5.3297 4.11976H11.2589C11.3472 4.11942 11.4347 4.13652 11.5164 4.17009C11.5981 4.20365 11.6724 4.25302 11.735 4.31535C11.7975 4.37769 11.8472 4.45177 11.8811 4.53334C11.915 4.61491 11.9324 4.70237 11.9324 4.79069C11.9324 4.87902 11.915 4.96648 11.8811 5.04805C11.8472 5.12962 11.7975 5.2037 11.735 5.26604C11.6724 5.32837 11.5981 5.37774 11.5164 5.4113C11.4347 5.44487 11.3472 5.46197 11.2589 5.46163H5.3297C5.06797 5.46214 4.81712 5.56642 4.63215 5.75159C4.44719 5.93677 4.34319 6.18773 4.34297 6.44946V18.6564C4.34323 18.918 4.44728 19.1688 4.63227 19.3538C4.81726 19.5388 5.06808 19.6428 5.3297 19.6431H17.4492C17.7108 19.6428 17.9616 19.5388 18.1466 19.3538C18.3316 19.1688 18.4356 18.918 18.4359 18.6564V12.5524C18.4359 12.3743 18.5067 12.2035 18.6326 12.0775C18.7585 11.9516 18.9293 11.8808 19.1074 11.8808C19.2855 11.8808 19.4563 11.9516 19.5822 12.0775C19.7082 12.2035 19.7789 12.3743 19.7789 12.5524L19.7789 12.5524ZM20.9482 3.42936C20.8971 3.30702 20.811 3.20247 20.7008 3.12878C20.5906 3.05508 20.4611 3.01551 20.3285 3.01502H15.3287C15.2404 3.01468 15.1529 3.03178 15.0712 3.06535C14.9895 3.09891 14.9152 3.14828 14.8526 3.21061C14.7901 3.27295 14.7404 3.34703 14.7065 3.4286C14.6726 3.51017 14.6552 3.59763 14.6552 3.68595C14.6552 3.77428 14.6726 3.86174 14.7065 3.94331C14.7404 4.02488 14.7901 4.09896 14.8526 4.1613C14.9152 4.22363 14.9895 4.273 15.0712 4.30656C15.1529 4.34013 15.2404 4.35723 15.3287 4.35689H18.7085L11.5544 11.511C11.429 11.637 11.3587 11.8076 11.3589 11.9854C11.3591 12.1632 11.4299 12.3336 11.5557 12.4593C11.6815 12.5849 11.852 12.6555 12.0298 12.6556C12.2076 12.6556 12.3782 12.5851 12.504 12.4595L19.657 5.30648V8.68628C19.657 8.86437 19.7278 9.03517 19.8537 9.1611C19.9796 9.28703 20.1504 9.35778 20.3285 9.35778C20.5066 9.35778 20.6774 9.28703 20.8033 9.1611C20.9293 9.03517 21 8.86437 21 8.68628V3.68598C20.9998 3.59786 20.9821 3.51066 20.9482 3.42935V3.42936Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                    </a>
                  </li>
                  <li style={{ boxSizing: "border-box", marginBottom: "8px" }}>
                    <button
                      tabIndex={0}
                      role="link"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        appearance: "none",
                        textTransform: "none",
                        overflow: "visible",
                        fontFamily:
                          "Avenir",
                        margin: "0px",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(157, 160, 165) none 0px",
                        border: "0px none rgb(157, 160, 165)",
                        borderRadius: "0px",
                        userSelect: "none",
                        verticalAlign: "middle",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Le compte des agents SNCF
                    </button>
                  </li>
                  <li style={{ boxSizing: "border-box", marginBottom: "8px" }}>
                    <button
                      tabIndex={0}
                      role="link"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        appearance: "none",
                        textTransform: "none",
                        overflow: "visible",
                        fontFamily:
                          "Avenir",
                        margin: "0px",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(157, 160, 165) none 0px",
                        border: "0px none rgb(157, 160, 165)",
                        borderRadius: "0px",
                        userSelect: "none",
                        verticalAlign: "middle",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Groupe-sncf.com
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          boxSizing: "border-box",
                          height: "16px",
                          width: "1rem",
                          alignSelf: "normal",
                          fill: "rgb(157, 160, 165)",
                          flexShrink: 0,
                          marginLeft: "6px",
                        }}
                      >
                        <path
                          d="M19.7789 12.5524V18.6564C19.778 19.2739 19.5322 19.8658 19.0955 20.3024C18.6587 20.7389 18.0667 20.9844 17.4492 20.985H5.3297C4.71219 20.9844 4.12012 20.7389 3.68338 20.3024C3.24663 19.8658 3.00087 19.2739 3 18.6564V6.44946C3.00064 5.83178 3.24629 5.23958 3.68306 4.80282C4.11982 4.36605 4.71202 4.1204 5.3297 4.11976H11.2589C11.3472 4.11942 11.4347 4.13652 11.5164 4.17009C11.5981 4.20365 11.6724 4.25302 11.735 4.31535C11.7975 4.37769 11.8472 4.45177 11.8811 4.53334C11.915 4.61491 11.9324 4.70237 11.9324 4.79069C11.9324 4.87902 11.915 4.96648 11.8811 5.04805C11.8472 5.12962 11.7975 5.2037 11.735 5.26604C11.6724 5.32837 11.5981 5.37774 11.5164 5.4113C11.4347 5.44487 11.3472 5.46197 11.2589 5.46163H5.3297C5.06797 5.46214 4.81712 5.56642 4.63215 5.75159C4.44719 5.93677 4.34319 6.18773 4.34297 6.44946V18.6564C4.34323 18.918 4.44728 19.1688 4.63227 19.3538C4.81726 19.5388 5.06808 19.6428 5.3297 19.6431H17.4492C17.7108 19.6428 17.9616 19.5388 18.1466 19.3538C18.3316 19.1688 18.4356 18.918 18.4359 18.6564V12.5524C18.4359 12.3743 18.5067 12.2035 18.6326 12.0775C18.7585 11.9516 18.9293 11.8808 19.1074 11.8808C19.2855 11.8808 19.4563 11.9516 19.5822 12.0775C19.7082 12.2035 19.7789 12.3743 19.7789 12.5524L19.7789 12.5524ZM20.9482 3.42936C20.8971 3.30702 20.811 3.20247 20.7008 3.12878C20.5906 3.05508 20.4611 3.01551 20.3285 3.01502H15.3287C15.2404 3.01468 15.1529 3.03178 15.0712 3.06535C14.9895 3.09891 14.9152 3.14828 14.8526 3.21061C14.7901 3.27295 14.7404 3.34703 14.7065 3.4286C14.6726 3.51017 14.6552 3.59763 14.6552 3.68595C14.6552 3.77428 14.6726 3.86174 14.7065 3.94331C14.7404 4.02488 14.7901 4.09896 14.8526 4.1613C14.9152 4.22363 14.9895 4.273 15.0712 4.30656C15.1529 4.34013 15.2404 4.35723 15.3287 4.35689H18.7085L11.5544 11.511C11.429 11.637 11.3587 11.8076 11.3589 11.9854C11.3591 12.1632 11.4299 12.3336 11.5557 12.4593C11.6815 12.5849 11.852 12.6555 12.0298 12.6556C12.2076 12.6556 12.3782 12.5851 12.504 12.4595L19.657 5.30648V8.68628C19.657 8.86437 19.7278 9.03517 19.8537 9.1611C19.9796 9.28703 20.1504 9.35778 20.3285 9.35778C20.5066 9.35778 20.6774 9.28703 20.8033 9.1611C20.9293 9.03517 21 8.86437 21 8.68628V3.68598C20.9998 3.59786 20.9821 3.51066 20.9482 3.42935V3.42936Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                    </button>
                  </li>
                  <li style={{ boxSizing: "border-box" }}>
                    <button
                      tabIndex={0}
                      role="link"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        appearance: "none",
                        textTransform: "none",
                        overflow: "visible",
                        fontFamily:
                          "Avenir",
                        margin: "0px",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(157, 160, 165) none 0px",
                        border: "0px none rgb(157, 160, 165)",
                        borderRadius: "0px",
                        userSelect: "none",
                        verticalAlign: "middle",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Emploi Groupe SNCF
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          boxSizing: "border-box",
                          height: "16px",
                          width: "1rem",
                          alignSelf: "normal",
                          fill: "rgb(157, 160, 165)",
                          flexShrink: 0,
                          marginLeft: "6px",
                        }}
                      >
                        <path
                          d="M19.7789 12.5524V18.6564C19.778 19.2739 19.5322 19.8658 19.0955 20.3024C18.6587 20.7389 18.0667 20.9844 17.4492 20.985H5.3297C4.71219 20.9844 4.12012 20.7389 3.68338 20.3024C3.24663 19.8658 3.00087 19.2739 3 18.6564V6.44946C3.00064 5.83178 3.24629 5.23958 3.68306 4.80282C4.11982 4.36605 4.71202 4.1204 5.3297 4.11976H11.2589C11.3472 4.11942 11.4347 4.13652 11.5164 4.17009C11.5981 4.20365 11.6724 4.25302 11.735 4.31535C11.7975 4.37769 11.8472 4.45177 11.8811 4.53334C11.915 4.61491 11.9324 4.70237 11.9324 4.79069C11.9324 4.87902 11.915 4.96648 11.8811 5.04805C11.8472 5.12962 11.7975 5.2037 11.735 5.26604C11.6724 5.32837 11.5981 5.37774 11.5164 5.4113C11.4347 5.44487 11.3472 5.46197 11.2589 5.46163H5.3297C5.06797 5.46214 4.81712 5.56642 4.63215 5.75159C4.44719 5.93677 4.34319 6.18773 4.34297 6.44946V18.6564C4.34323 18.918 4.44728 19.1688 4.63227 19.3538C4.81726 19.5388 5.06808 19.6428 5.3297 19.6431H17.4492C17.7108 19.6428 17.9616 19.5388 18.1466 19.3538C18.3316 19.1688 18.4356 18.918 18.4359 18.6564V12.5524C18.4359 12.3743 18.5067 12.2035 18.6326 12.0775C18.7585 11.9516 18.9293 11.8808 19.1074 11.8808C19.2855 11.8808 19.4563 11.9516 19.5822 12.0775C19.7082 12.2035 19.7789 12.3743 19.7789 12.5524L19.7789 12.5524ZM20.9482 3.42936C20.8971 3.30702 20.811 3.20247 20.7008 3.12878C20.5906 3.05508 20.4611 3.01551 20.3285 3.01502H15.3287C15.2404 3.01468 15.1529 3.03178 15.0712 3.06535C14.9895 3.09891 14.9152 3.14828 14.8526 3.21061C14.7901 3.27295 14.7404 3.34703 14.7065 3.4286C14.6726 3.51017 14.6552 3.59763 14.6552 3.68595C14.6552 3.77428 14.6726 3.86174 14.7065 3.94331C14.7404 4.02488 14.7901 4.09896 14.8526 4.1613C14.9152 4.22363 14.9895 4.273 15.0712 4.30656C15.1529 4.34013 15.2404 4.35723 15.3287 4.35689H18.7085L11.5544 11.511C11.429 11.637 11.3587 11.8076 11.3589 11.9854C11.3591 12.1632 11.4299 12.3336 11.5557 12.4593C11.6815 12.5849 11.852 12.6555 12.0298 12.6556C12.2076 12.6556 12.3782 12.5851 12.504 12.4595L19.657 5.30648V8.68628C19.657 8.86437 19.7278 9.03517 19.8537 9.1611C19.9796 9.28703 20.1504 9.35778 20.3285 9.35778C20.5066 9.35778 20.6774 9.28703 20.8033 9.1611C20.9293 9.03517 21 8.86437 21 8.68628V3.68598C20.9998 3.59786 20.9821 3.51066 20.9482 3.42935V3.42936Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                    </button>
                  </li>
                </ul>
              </div>
              <div style={{ marginTop: "0px", boxSizing: "border-box" }}>
                <p
                  style={{
                    fontSize: "16px",
                    lineHeight: "22px",
                    boxSizing: "border-box",
                    margin: "0px 0px 8px",
                    fontFamily: "Avenir",
                    fontWeight: 700,
                  }}
                >
                  Vous informer
                </p>
                <ul
                  style={{
                    boxSizing: "border-box",
                    listStyle: "outside none none",
                    margin: "0px",
                    padding: "0px",
                  }}
                >
                  <li style={{ boxSizing: "border-box", marginBottom: "8px" }}>
                    <button
                      tabIndex={0}
                      role="link"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        appearance: "none",
                        textTransform: "none",
                        overflow: "visible",
                        fontFamily:
                          "Avenir",
                        margin: "0px",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(157, 160, 165) none 0px",
                        border: "0px none rgb(157, 160, 165)",
                        borderRadius: "0px",
                        userSelect: "none",
                        verticalAlign: "middle",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Aide
                    </button>
                  </li>
                  <li style={{ boxSizing: "border-box", marginBottom: "8px" }}>
                    <button
                      tabIndex={0}
                      role="link"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        appearance: "none",
                        textTransform: "none",
                        overflow: "visible",
                        fontFamily:
                          "Avenir",
                        margin: "0px",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(157, 160, 165) none 0px",
                        border: "0px none rgb(157, 160, 165)",
                        borderRadius: "0px",
                        userSelect: "none",
                        verticalAlign: "middle",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Contactez-nous
                    </button>
                  </li>
                  <li style={{ boxSizing: "border-box", marginBottom: "8px" }}>
                    <button
                      tabIndex={0}
                      role="link"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        appearance: "none",
                        textTransform: "none",
                        overflow: "visible",
                        fontFamily:
                          "Avenir",
                        margin: "0px",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(157, 160, 165) none 0px",
                        border: "0px none rgb(157, 160, 165)",
                        borderRadius: "0px",
                        userSelect: "none",
                        verticalAlign: "middle",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Vos billets
                    </button>
                  </li>
                  <li style={{ boxSizing: "border-box", marginBottom: "8px" }}>
                    <a
                      href="https://vous.sncf-connect.com"
                      target="_blank"
                      title="Communauté SNCF Connect - Nouvel Onglet"
                      rel="noopener noreferrer"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Communauté SNCF Connect
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          boxSizing: "border-box",
                          height: "16px",
                          width: "1rem",
                          alignSelf: "normal",
                          fill: "rgb(157, 160, 165)",
                          flexShrink: 0,
                          marginLeft: "6px",
                        }}
                      >
                        <path
                          d="M19.7789 12.5524V18.6564C19.778 19.2739 19.5322 19.8658 19.0955 20.3024C18.6587 20.7389 18.0667 20.9844 17.4492 20.985H5.3297C4.71219 20.9844 4.12012 20.7389 3.68338 20.3024C3.24663 19.8658 3.00087 19.2739 3 18.6564V6.44946C3.00064 5.83178 3.24629 5.23958 3.68306 4.80282C4.11982 4.36605 4.71202 4.1204 5.3297 4.11976H11.2589C11.3472 4.11942 11.4347 4.13652 11.5164 4.17009C11.5981 4.20365 11.6724 4.25302 11.735 4.31535C11.7975 4.37769 11.8472 4.45177 11.8811 4.53334C11.915 4.61491 11.9324 4.70237 11.9324 4.79069C11.9324 4.87902 11.915 4.96648 11.8811 5.04805C11.8472 5.12962 11.7975 5.2037 11.735 5.26604C11.6724 5.32837 11.5981 5.37774 11.5164 5.4113C11.4347 5.44487 11.3472 5.46197 11.2589 5.46163H5.3297C5.06797 5.46214 4.81712 5.56642 4.63215 5.75159C4.44719 5.93677 4.34319 6.18773 4.34297 6.44946V18.6564C4.34323 18.918 4.44728 19.1688 4.63227 19.3538C4.81726 19.5388 5.06808 19.6428 5.3297 19.6431H17.4492C17.7108 19.6428 17.9616 19.5388 18.1466 19.3538C18.3316 19.1688 18.4356 18.918 18.4359 18.6564V12.5524C18.4359 12.3743 18.5067 12.2035 18.6326 12.0775C18.7585 11.9516 18.9293 11.8808 19.1074 11.8808C19.2855 11.8808 19.4563 11.9516 19.5822 12.0775C19.7082 12.2035 19.7789 12.3743 19.7789 12.5524L19.7789 12.5524ZM20.9482 3.42936C20.8971 3.30702 20.811 3.20247 20.7008 3.12878C20.5906 3.05508 20.4611 3.01551 20.3285 3.01502H15.3287C15.2404 3.01468 15.1529 3.03178 15.0712 3.06535C14.9895 3.09891 14.9152 3.14828 14.8526 3.21061C14.7901 3.27295 14.7404 3.34703 14.7065 3.4286C14.6726 3.51017 14.6552 3.59763 14.6552 3.68595C14.6552 3.77428 14.6726 3.86174 14.7065 3.94331C14.7404 4.02488 14.7901 4.09896 14.8526 4.1613C14.9152 4.22363 14.9895 4.273 15.0712 4.30656C15.1529 4.34013 15.2404 4.35723 15.3287 4.35689H18.7085L11.5544 11.511C11.429 11.637 11.3587 11.8076 11.3589 11.9854C11.3591 12.1632 11.4299 12.3336 11.5557 12.4593C11.6815 12.5849 11.852 12.6555 12.0298 12.6556C12.2076 12.6556 12.3782 12.5851 12.504 12.4595L19.657 5.30648V8.68628C19.657 8.86437 19.7278 9.03517 19.8537 9.1611C19.9796 9.28703 20.1504 9.35778 20.3285 9.35778C20.5066 9.35778 20.6774 9.28703 20.8033 9.1611C20.9293 9.03517 21 8.86437 21 8.68628V3.68598C20.9998 3.59786 20.9821 3.51066 20.9482 3.42935V3.42936Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                    </a>
                  </li>
                  <li style={{ boxSizing: "border-box", marginBottom: "8px" }}>
                    <a
                      href="/plan-du-site"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Plan du site SNCF Connect
                    </a>
                  </li>
                  <li style={{ boxSizing: "border-box", marginBottom: "8px" }}>
                    <a
                      href="/services-train/guide-voyageur"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Guide du voyageur
                    </a>
                  </li>
                  <li style={{ boxSizing: "border-box" }}>
                    <button
                      tabIndex={0}
                      role="link"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        appearance: "none",
                        textTransform: "none",
                        overflow: "visible",
                        fontFamily:
                          "Avenir",
                        margin: "0px",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(157, 160, 165) none 0px",
                        border: "0px none rgb(157, 160, 165)",
                        borderRadius: "0px",
                        userSelect: "none",
                        verticalAlign: "middle",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Franchissement frontière
                    </button>
                  </li>
                </ul>
              </div>
              <div style={{ marginTop: "0px", boxSizing: "border-box" }}>
                <p
                  style={{
                    fontSize: "16px",
                    lineHeight: "22px",
                    boxSizing: "border-box",
                    margin: "0px 0px 8px",
                    fontFamily: "Avenir",
                    fontWeight: 700,
                  }}
                >
                  Handicap &amp; mobilité réduite
                </p>
                <ul
                  style={{
                    boxSizing: "border-box",
                    listStyle: "outside none none",
                    margin: "0px",
                    padding: "0px",
                  }}
                >
                  <li style={{ boxSizing: "border-box", marginBottom: "8px" }}>
                    <a
                      href="/accessibilite"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Accessibilité numérique : conformité partielle
                    </a>
                  </li>
                  <li style={{ boxSizing: "border-box", marginBottom: "8px" }}>
                    <button
                      tabIndex={0}
                      role="link"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        appearance: "none",
                        textTransform: "none",
                        overflow: "visible",
                        fontFamily:
                          "Avenir",
                        margin: "0px",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(157, 160, 165) none 0px",
                        border: "0px none rgb(157, 160, 165)",
                        borderRadius: "0px",
                        userSelect: "none",
                        verticalAlign: "middle",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Préparez votre voyage sur SNCF Connect
                    </button>
                  </li>
                  <li style={{ boxSizing: "border-box", marginBottom: "8px" }}>
                    <a
                      href="https://www.garesetconnexions.sncf/fr/service-client/service-assistance-gare-PMR"
                      target="_blank"
                      title="Tout savoir sur le service d'assistance en gare - Nouvel Onglet"
                      rel="noopener noreferrer"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Tout savoir sur le service d'assistance en gare
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          boxSizing: "border-box",
                          height: "16px",
                          width: "1rem",
                          alignSelf: "normal",
                          fill: "rgb(157, 160, 165)",
                          flexShrink: 0,
                          marginLeft: "6px",
                        }}
                      >
                        <path
                          d="M19.7789 12.5524V18.6564C19.778 19.2739 19.5322 19.8658 19.0955 20.3024C18.6587 20.7389 18.0667 20.9844 17.4492 20.985H5.3297C4.71219 20.9844 4.12012 20.7389 3.68338 20.3024C3.24663 19.8658 3.00087 19.2739 3 18.6564V6.44946C3.00064 5.83178 3.24629 5.23958 3.68306 4.80282C4.11982 4.36605 4.71202 4.1204 5.3297 4.11976H11.2589C11.3472 4.11942 11.4347 4.13652 11.5164 4.17009C11.5981 4.20365 11.6724 4.25302 11.735 4.31535C11.7975 4.37769 11.8472 4.45177 11.8811 4.53334C11.915 4.61491 11.9324 4.70237 11.9324 4.79069C11.9324 4.87902 11.915 4.96648 11.8811 5.04805C11.8472 5.12962 11.7975 5.2037 11.735 5.26604C11.6724 5.32837 11.5981 5.37774 11.5164 5.4113C11.4347 5.44487 11.3472 5.46197 11.2589 5.46163H5.3297C5.06797 5.46214 4.81712 5.56642 4.63215 5.75159C4.44719 5.93677 4.34319 6.18773 4.34297 6.44946V18.6564C4.34323 18.918 4.44728 19.1688 4.63227 19.3538C4.81726 19.5388 5.06808 19.6428 5.3297 19.6431H17.4492C17.7108 19.6428 17.9616 19.5388 18.1466 19.3538C18.3316 19.1688 18.4356 18.918 18.4359 18.6564V12.5524C18.4359 12.3743 18.5067 12.2035 18.6326 12.0775C18.7585 11.9516 18.9293 11.8808 19.1074 11.8808C19.2855 11.8808 19.4563 11.9516 19.5822 12.0775C19.7082 12.2035 19.7789 12.3743 19.7789 12.5524L19.7789 12.5524ZM20.9482 3.42936C20.8971 3.30702 20.811 3.20247 20.7008 3.12878C20.5906 3.05508 20.4611 3.01551 20.3285 3.01502H15.3287C15.2404 3.01468 15.1529 3.03178 15.0712 3.06535C14.9895 3.09891 14.9152 3.14828 14.8526 3.21061C14.7901 3.27295 14.7404 3.34703 14.7065 3.4286C14.6726 3.51017 14.6552 3.59763 14.6552 3.68595C14.6552 3.77428 14.6726 3.86174 14.7065 3.94331C14.7404 4.02488 14.7901 4.09896 14.8526 4.1613C14.9152 4.22363 14.9895 4.273 15.0712 4.30656C15.1529 4.34013 15.2404 4.35723 15.3287 4.35689H18.7085L11.5544 11.511C11.429 11.637 11.3587 11.8076 11.3589 11.9854C11.3591 12.1632 11.4299 12.3336 11.5557 12.4593C11.6815 12.5849 11.852 12.6555 12.0298 12.6556C12.2076 12.6556 12.3782 12.5851 12.504 12.4595L19.657 5.30648V8.68628C19.657 8.86437 19.7278 9.03517 19.8537 9.1611C19.9796 9.28703 20.1504 9.35778 20.3285 9.35778C20.5066 9.35778 20.6774 9.28703 20.8033 9.1611C20.9293 9.03517 21 8.86437 21 8.68628V3.68598C20.9998 3.59786 20.9821 3.51066 20.9482 3.42935V3.42936Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                    </a>
                  </li>
                  <li style={{ boxSizing: "border-box" }}>
                    <a
                      href="https://railprmassistance.uic.org/"
                      target="_blank"
                      title="Les autres services d'assistance en Europe - Nouvel Onglet"
                      rel="noopener noreferrer"
                      style={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        boxSizing: "border-box",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                        textDecoration: "none solid rgb(157, 160, 165)",
                        cursor: "pointer",
                        position: "relative",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        color: "rgb(157, 160, 165)",
                        textAlign: "left",
                        padding: "8px 0px",
                        width: "fit-content",
                      }}
                    >
                      Les autres services d'assistance en Europe
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          boxSizing: "border-box",
                          height: "16px",
                          width: "1rem",
                          alignSelf: "normal",
                          fill: "rgb(157, 160, 165)",
                          flexShrink: 0,
                          marginLeft: "6px",
                        }}
                      >
                        <path
                          d="M19.7789 12.5524V18.6564C19.778 19.2739 19.5322 19.8658 19.0955 20.3024C18.6587 20.7389 18.0667 20.9844 17.4492 20.985H5.3297C4.71219 20.9844 4.12012 20.7389 3.68338 20.3024C3.24663 19.8658 3.00087 19.2739 3 18.6564V6.44946C3.00064 5.83178 3.24629 5.23958 3.68306 4.80282C4.11982 4.36605 4.71202 4.1204 5.3297 4.11976H11.2589C11.3472 4.11942 11.4347 4.13652 11.5164 4.17009C11.5981 4.20365 11.6724 4.25302 11.735 4.31535C11.7975 4.37769 11.8472 4.45177 11.8811 4.53334C11.915 4.61491 11.9324 4.70237 11.9324 4.79069C11.9324 4.87902 11.915 4.96648 11.8811 5.04805C11.8472 5.12962 11.7975 5.2037 11.735 5.26604C11.6724 5.32837 11.5981 5.37774 11.5164 5.4113C11.4347 5.44487 11.3472 5.46197 11.2589 5.46163H5.3297C5.06797 5.46214 4.81712 5.56642 4.63215 5.75159C4.44719 5.93677 4.34319 6.18773 4.34297 6.44946V18.6564C4.34323 18.918 4.44728 19.1688 4.63227 19.3538C4.81726 19.5388 5.06808 19.6428 5.3297 19.6431H17.4492C17.7108 19.6428 17.9616 19.5388 18.1466 19.3538C18.3316 19.1688 18.4356 18.918 18.4359 18.6564V12.5524C18.4359 12.3743 18.5067 12.2035 18.6326 12.0775C18.7585 11.9516 18.9293 11.8808 19.1074 11.8808C19.2855 11.8808 19.4563 11.9516 19.5822 12.0775C19.7082 12.2035 19.7789 12.3743 19.7789 12.5524L19.7789 12.5524ZM20.9482 3.42936C20.8971 3.30702 20.811 3.20247 20.7008 3.12878C20.5906 3.05508 20.4611 3.01551 20.3285 3.01502H15.3287C15.2404 3.01468 15.1529 3.03178 15.0712 3.06535C14.9895 3.09891 14.9152 3.14828 14.8526 3.21061C14.7901 3.27295 14.7404 3.34703 14.7065 3.4286C14.6726 3.51017 14.6552 3.59763 14.6552 3.68595C14.6552 3.77428 14.6726 3.86174 14.7065 3.94331C14.7404 4.02488 14.7901 4.09896 14.8526 4.1613C14.9152 4.22363 14.9895 4.273 15.0712 4.30656C15.1529 4.34013 15.2404 4.35723 15.3287 4.35689H18.7085L11.5544 11.511C11.429 11.637 11.3587 11.8076 11.3589 11.9854C11.3591 12.1632 11.4299 12.3336 11.5557 12.4593C11.6815 12.5849 11.852 12.6555 12.0298 12.6556C12.2076 12.6556 12.3782 12.5851 12.504 12.4595L19.657 5.30648V8.68628C19.657 8.86437 19.7278 9.03517 19.8537 9.1611C19.9796 9.28703 20.1504 9.35778 20.3285 9.35778C20.5066 9.35778 20.6774 9.28703 20.8033 9.1611C20.9293 9.03517 21 8.86437 21 8.68628V3.68598C20.9998 3.59786 20.9821 3.51066 20.9482 3.42935V3.42936Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <hr
              aria-hidden="true"
              style={{
                boxSizing: "content-box",
                height: "2px",
                overflow: "visible",
                margin: "0px",
                flexShrink: 0,
                borderWidth: "0px",
                borderColor: "rgb(173, 255, 47)",
                backgroundColor: "rgb(36, 43, 53)",
                borderStyle: "none",
              }}
            />
            <div style={{ boxSizing: "border-box", margin: "0px -16px" }}>
              <div
                style={{
                  boxSizing: "border-box",
                  borderTopLeftRadius: "14px",
                  borderTopRightRadius: "14px",
                  color: "rgb(243, 243, 244)",
                  boxShadow: "none",
                  backgroundImage:
                    "linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0))",
                  position: "relative",
                  transition: "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                  overflowAnchor: "none",
                  borderRadius: "14px 14px 0px 0px",
                  backgroundColor: "rgba(0, 0, 0, 0)",
                }}
              >
                <div
                  tabIndex={0}
                  role="button"
                  aria-expanded="false"
                  aria-controls="expansion-carriers-content"
                  style={{
                    boxSizing: "border-box",
                    WebkitBoxAlign: "center",
                    alignItems: "center",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    position: "relative",
                    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                    backgroundColor: "rgba(0, 0, 0, 0)",
                    outline: "rgb(243, 243, 244) none 0px",
                    border: "0px none rgb(243, 243, 244)",
                    margin: "0px",
                    borderRadius: "0px",
                    cursor: "pointer",
                    userSelect: "none",
                    verticalAlign: "middle",
                    appearance: "none",
                    textDecoration: "none solid rgb(243, 243, 244)",
                    color: "rgb(243, 243, 244)",
                    display: "flex",
                    transition:
                      "min-height 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s, background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                    padding: "16px",
                    minHeight: "56px",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      display: "flex",
                      WebkitBoxFlex: 1,
                      flexGrow: 1,
                      transition:
                        "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      margin: "0px",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "16px",
                        lineHeight: "22px",
                        boxSizing: "border-box",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                      }}
                    >
                      Transporteurs
                    </p>
                  </div>
                  <div
                    style={{
                      boxSizing: "border-box",
                      display: "flex",
                      color: "rgb(243, 243, 244)",
                      transform: "matrix(1, 0, 0, 1, 0, 0)",
                      transition:
                        "transform 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      marginRight: "-16px",
                      padding: "0px 16px",
                    }}
                  >
                    <svg
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        boxSizing: "border-box",
                        fill: "rgb(141, 232, 254)",
                        height: "24px",
                        width: "1.5rem",
                      }}
                    >
                      <path
                        d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                    </svg>
                  </div>
                </div>
                <div
                  style={{
                    minHeight: "0pxbox-sizing:border-box",
                    boxSizing: "border-box",
                    height: "0px",
                    overflow: "hidden",
                    transition: "height 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                    visibility: "hidden",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      display: "flex",
                      width: "100%",
                    }}
                  >
                    <div style={{ boxSizing: "border-box", width: "100%" }}>
                      <div
                        aria-labelledby="expansion-carriers-summary"
                        role="region"
                        style={{ boxSizing: "border-box" }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            marginBottom: "16px",
                            padding: "0px 16px",
                          }}
                        >
                          <ul
                            style={{
                              columnGap: "24px",
                              display: "grid",
                              gridTemplateColumns:
                                "236.797px 236.797px 236.797px 236.797px 236.812px",
                              width: "100%",
                              boxSizing: "border-box",
                              listStyle: "outside none none",
                              margin: "0px",
                              padding: "0px",
                            }}
                          >
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/tgv-inoui"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                TGV INOUI
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/ouigo"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                OUIGO
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/ter"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                TER
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/blablacar-bus"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                BlaBlaCar Bus
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/flixbus"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                FlixBus
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/blablacar"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                BlaBlaCar
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/intercites"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                INTERCITÉS
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/tgv-lyria"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                TGV Lyria
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/eurostar"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Eurostar
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/tgv-inoui-bruxelles"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                TGV INOUI vers Bruxelles
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/db-sncf-cooperation"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                DB SNCF Voyageurs en coopération
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/tgv-inoui-espagne"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                TGV INOUI vers l'Espagne
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/tgv-inoui-italie"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                TGV INOUI vers l'Italie
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/tgv-inoui-luxembourg"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                TGV INOUI vers le Luxembourg
                              </a>
                            </li>
                            <li style={{ boxSizing: "border-box" }}>
                              <a
                                href="/obb-nightjet"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                OBB Nightjet
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr
                aria-hidden="true"
                style={{
                  boxSizing: "content-box",
                  height: "2px",
                  overflow: "visible",
                  flexShrink: 0,
                  borderWidth: "0px",
                  borderColor: "rgb(173, 255, 47)",
                  backgroundColor: "rgb(36, 43, 53)",
                  borderStyle: "none",
                  margin: "0px 16px",
                }}
              />
              <div
                style={{
                  boxSizing: "border-box",
                  color: "rgb(243, 243, 244)",
                  boxShadow: "none",
                  backgroundImage:
                    "linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0))",
                  position: "relative",
                  transition: "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                  overflowAnchor: "none",
                  borderRadius: "0px",
                  backgroundColor: "rgba(0, 0, 0, 0)",
                }}
              >
                <div
                  tabIndex={0}
                  role="button"
                  aria-expanded="false"
                  aria-controls="expansion-topDestination-content"
                  style={{
                    boxSizing: "border-box",
                    WebkitBoxAlign: "center",
                    alignItems: "center",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    position: "relative",
                    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                    backgroundColor: "rgba(0, 0, 0, 0)",
                    outline: "rgb(243, 243, 244) none 0px",
                    border: "0px none rgb(243, 243, 244)",
                    margin: "0px",
                    borderRadius: "0px",
                    cursor: "pointer",
                    userSelect: "none",
                    verticalAlign: "middle",
                    appearance: "none",
                    textDecoration: "none solid rgb(243, 243, 244)",
                    color: "rgb(243, 243, 244)",
                    display: "flex",
                    transition:
                      "min-height 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s, background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                    padding: "16px",
                    minHeight: "56px",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      display: "flex",
                      WebkitBoxFlex: 1,
                      flexGrow: 1,
                      transition:
                        "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      margin: "0px",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "16px",
                        lineHeight: "22px",
                        boxSizing: "border-box",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                      }}
                    >
                      Itinéraires populaires
                    </p>
                  </div>
                  <div
                    style={{
                      boxSizing: "border-box",
                      display: "flex",
                      color: "rgb(243, 243, 244)",
                      transform: "matrix(1, 0, 0, 1, 0, 0)",
                      transition:
                        "transform 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      marginRight: "-16px",
                      padding: "0px 16px",
                    }}
                  >
                    <svg
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        boxSizing: "border-box",
                        fill: "rgb(141, 232, 254)",
                        height: "24px",
                        width: "1.5rem",
                      }}
                    >
                      <path
                        d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                    </svg>
                  </div>
                </div>
                <div
                  style={{
                    minHeight: "0pxbox-sizing:border-box",
                    boxSizing: "border-box",
                    height: "0px",
                    overflow: "hidden",
                    transition: "height 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                    visibility: "hidden",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      display: "flex",
                      width: "100%",
                    }}
                  >
                    <div style={{ boxSizing: "border-box", width: "100%" }}>
                      <div
                        aria-labelledby="expansion-topDestination-summary"
                        role="region"
                        style={{ boxSizing: "border-box" }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            marginBottom: "16px",
                            padding: "0px 16px",
                          }}
                        >
                          <ul
                            style={{
                              columnGap: "24px",
                              display: "grid",
                              gridTemplateColumns:
                                "236.797px 236.797px 236.797px 236.797px 236.812px",
                              width: "100%",
                              boxSizing: "border-box",
                              listStyle: "outside none none",
                              margin: "0px",
                              padding: "0px",
                            }}
                          >
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/trajet/paris/bordeaux"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Paris Bordeaux
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/trajet/paris/marseille"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Paris Marseille
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/trajet/bordeaux/paris"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Bordeaux Paris
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/trajet/paris/lyon"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Paris Lyon
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/trajet/paris/bruxelles"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Paris Bruxelles
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/trajet/paris/strasbourg"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Paris Strasbourg
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/trajet/paris/toulouse"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Paris Toulouse
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/trajet/toulouse/paris"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Toulouse Paris
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/trajet/lyon/paris"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Lyon Paris
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/trajet/paris/amsterdam"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Paris Amsterdam
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/trajet/paris/lille"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Paris Lille
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/trajet/nantes/paris"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Nantes Paris
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/trajet/paris/geneve"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Paris Genève
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/trajet/paris/barcelone"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Paris Barcelone
                              </a>
                            </li>
                            <li style={{ boxSizing: "border-box" }}>
                              <a
                                href="/train/trajet/paris/nantes"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Paris Nantes
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr
                aria-hidden="true"
                style={{
                  boxSizing: "content-box",
                  height: "2px",
                  overflow: "visible",
                  flexShrink: 0,
                  borderWidth: "0px",
                  borderColor: "rgb(173, 255, 47)",
                  backgroundColor: "rgb(36, 43, 53)",
                  borderStyle: "none",
                  margin: "0px 16px",
                }}
              />
              <div
                style={{
                  boxSizing: "border-box",
                  color: "rgb(243, 243, 244)",
                  boxShadow: "none",
                  backgroundImage:
                    "linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0))",
                  position: "relative",
                  transition: "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                  overflowAnchor: "none",
                  borderRadius: "0px",
                  backgroundColor: "rgba(0, 0, 0, 0)",
                }}
              >
                <div
                  tabIndex={0}
                  role="button"
                  aria-expanded="false"
                  aria-controls="expansion-topWeekEndDestination-content"
                  style={{
                    boxSizing: "border-box",
                    WebkitBoxAlign: "center",
                    alignItems: "center",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    position: "relative",
                    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                    backgroundColor: "rgba(0, 0, 0, 0)",
                    outline: "rgb(243, 243, 244) none 0px",
                    border: "0px none rgb(243, 243, 244)",
                    margin: "0px",
                    borderRadius: "0px",
                    cursor: "pointer",
                    userSelect: "none",
                    verticalAlign: "middle",
                    appearance: "none",
                    textDecoration: "none solid rgb(243, 243, 244)",
                    color: "rgb(243, 243, 244)",
                    display: "flex",
                    transition:
                      "min-height 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s, background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                    padding: "16px",
                    minHeight: "56px",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      display: "flex",
                      WebkitBoxFlex: 1,
                      flexGrow: 1,
                      transition:
                        "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      margin: "0px",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "16px",
                        lineHeight: "22px",
                        boxSizing: "border-box",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                      }}
                    >
                      Trajets Transporteurs
                    </p>
                  </div>
                  <div
                    style={{
                      boxSizing: "border-box",
                      display: "flex",
                      color: "rgb(243, 243, 244)",
                      transform: "matrix(1, 0, 0, 1, 0, 0)",
                      transition:
                        "transform 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      marginRight: "-16px",
                      padding: "0px 16px",
                    }}
                  >
                    <svg
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        boxSizing: "border-box",
                        fill: "rgb(141, 232, 254)",
                        height: "24px",
                        width: "1.5rem",
                      }}
                    >
                      <path
                        d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                    </svg>
                  </div>
                </div>
                <div
                  style={{
                    minHeight: "0pxbox-sizing:border-box",
                    boxSizing: "border-box",
                    height: "0px",
                    overflow: "hidden",
                    transition: "height 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                    visibility: "hidden",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      display: "flex",
                      width: "100%",
                    }}
                  >
                    <div style={{ boxSizing: "border-box", width: "100%" }}>
                      <div
                        aria-labelledby="expansion-topWeekEndDestination-summary"
                        role="region"
                        style={{ boxSizing: "border-box" }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            marginBottom: "16px",
                            padding: "0px 16px",
                          }}
                        >
                          <ul
                            style={{
                              columnGap: "24px",
                              display: "grid",
                              gridTemplateColumns:
                                "236.797px 236.797px 236.797px 236.797px 236.812px",
                              width: "100%",
                              boxSizing: "border-box",
                              listStyle: "outside none none",
                              margin: "0px",
                              padding: "0px",
                            }}
                          >
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/tgv-inoui/trajet/lille/paris"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                TGV INOUI Lille-Paris
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/tgv-inoui/trajet/lyon/paris"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                TGV INOUI Lyon-Paris
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/tgv-inoui/trajet/paris/nice"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                TGV INOUI Paris-Nice
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/tgv-inoui/trajet/marseille/paris"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                TGV INOUI Marseille-Paris
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/tgv-inoui/trajet/paris/nantes"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                TGV INOUI Paris-Nantes
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/ouigo/trajet/fleury-les-aubrais/paris"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                OUIGO Fleury-les-Aubrais-Paris
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/ouigo/trajet/paris/fleury-les-aubrais"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                OUIGO Paris-Fleury-les-Aubrais
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/ouigo/trajet/rennes/paris"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                OUIGO Rennes-Paris
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/ouigo/trajet/marseille/lyon"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                OUIGO Marseille-Lyon
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/ouigo/trajet/nantes/paris"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                OUIGO Nantes-Paris
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/ter/trajet/paris/trouville-deauville"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                TER Paris-Trouville Deauville
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/ter/trajet/trouville-deauville/paris"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                TER Trouville Deauville-Paris
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/ter/trajet/paris/le-mans"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                TER Paris-Le Mans
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/ter/trajet/le-mans/paris"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                TER Le Mans-Paris
                              </a>
                            </li>
                            <li style={{ boxSizing: "border-box" }}>
                              <a
                                href="/ter/trajet/nice/cannes"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                TER Nice-Cannes
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr
                aria-hidden="true"
                style={{
                  boxSizing: "content-box",
                  height: "2px",
                  overflow: "visible",
                  flexShrink: 0,
                  borderWidth: "0px",
                  borderColor: "rgb(173, 255, 47)",
                  backgroundColor: "rgb(36, 43, 53)",
                  borderStyle: "none",
                  margin: "0px 16px",
                }}
              />
              <div
                style={{
                  boxSizing: "border-box",
                  borderBottomLeftRadius: "14px",
                  borderBottomRightRadius: "14px",
                  color: "rgb(243, 243, 244)",
                  boxShadow: "none",
                  backgroundImage:
                    "linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0))",
                  position: "relative",
                  transition: "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                  overflowAnchor: "none",
                  borderRadius: "0px 0px 14px 14px",
                  backgroundColor: "rgba(0, 0, 0, 0)",
                }}
              >
                <div
                  tabIndex={0}
                  role="button"
                  aria-expanded="false"
                  aria-controls="expansion-topGenericDestination-content"
                  style={{
                    boxSizing: "border-box",
                    WebkitBoxAlign: "center",
                    alignItems: "center",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    position: "relative",
                    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                    backgroundColor: "rgba(0, 0, 0, 0)",
                    outline: "rgb(243, 243, 244) none 0px",
                    border: "0px none rgb(243, 243, 244)",
                    margin: "0px",
                    borderRadius: "0px",
                    cursor: "pointer",
                    userSelect: "none",
                    verticalAlign: "middle",
                    appearance: "none",
                    textDecoration: "none solid rgb(243, 243, 244)",
                    color: "rgb(243, 243, 244)",
                    display: "flex",
                    transition:
                      "min-height 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s, background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                    padding: "16px",
                    minHeight: "56px",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      display: "flex",
                      WebkitBoxFlex: 1,
                      flexGrow: 1,
                      transition:
                        "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      margin: "0px",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "16px",
                        lineHeight: "22px",
                        boxSizing: "border-box",
                        margin: "0px",
                        fontFamily:
                          "Avenir",
                        fontWeight: 700,
                      }}
                    >
                      Top destinations
                    </p>
                  </div>
                  <div
                    style={{
                      boxSizing: "border-box",
                      display: "flex",
                      color: "rgb(243, 243, 244)",
                      transform: "matrix(1, 0, 0, 1, 0, 0)",
                      transition:
                        "transform 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      marginRight: "-16px",
                      padding: "0px 16px",
                    }}
                  >
                    <svg
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        boxSizing: "border-box",
                        fill: "rgb(141, 232, 254)",
                        height: "24px",
                        width: "1.5rem",
                      }}
                    >
                      <path
                        d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                    </svg>
                  </div>
                </div>
                <div
                  style={{
                    minHeight: "0pxbox-sizing:border-box",
                    boxSizing: "border-box",
                    height: "0px",
                    overflow: "hidden",
                    transition: "height 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                    visibility: "hidden",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      display: "flex",
                      width: "100%",
                    }}
                  >
                    <div style={{ boxSizing: "border-box", width: "100%" }}>
                      <div
                        aria-labelledby="expansion-topGenericDestination-summary"
                        role="region"
                        style={{ boxSizing: "border-box" }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            marginBottom: "16px",
                            padding: "0px 16px",
                          }}
                        >
                          <ul
                            style={{
                              columnGap: "24px",
                              display: "grid",
                              gridTemplateColumns:
                                "236.797px 236.797px 236.797px 236.797px 236.812px",
                              width: "100%",
                              boxSizing: "border-box",
                              listStyle: "outside none none",
                              margin: "0px",
                              padding: "0px",
                            }}
                          >
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/france"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train France
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/france/ile-de-france/paris"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Paris
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/france/auvergne-rhone-alpes/lyon"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Lyon
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/france/nouvelle-aquitaine/bordeaux"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Bordeaux
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/france/grand-est/strasbourg"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Strasbourg
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/france/pays-de-la-loire/nantes"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Nantes
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/france/provence-alpes-cote-d-azur/marseille"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Marseille
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/france/hauts-de-france/lille"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Lille
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/france/ile-de-france/chessy/marne-la-vallee-chessy"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Marne-la-Vallée Chessy
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/pays-bas/amsterdam"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Amsterdam
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/royaume-uni/angleterre/londres"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Londres
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/espagne/catalogne/barcelone"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Barcelone
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/france/bretagne/rennes"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Rennes
                              </a>
                            </li>
                            <li
                              style={{
                                boxSizing: "border-box",
                                marginBottom: "8px",
                              }}
                            >
                              <a
                                href="/train/italie"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Italie
                              </a>
                            </li>
                            <li style={{ boxSizing: "border-box" }}>
                              <a
                                href="/train/suisse"
                                style={{
                                  fontSize: "13px",
                                  lineHeight: "18px",
                                  boxSizing: "border-box",
                                  backgroundColor: "rgba(0, 0, 0, 0)",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 700,
                                  textDecoration:
                                    "none solid rgb(157, 160, 165)",
                                  cursor: "pointer",
                                  position: "relative",
                                  WebkitBoxAlign: "center",
                                  alignItems: "center",
                                  display: "inline-flex",
                                  color: "rgb(157, 160, 165)",
                                  textAlign: "left",
                                  padding: "8px 0px",
                                  width: "fit-content",
                                }}
                              >
                                Train Suisse
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr
                aria-hidden="true"
                style={{
                  boxSizing: "content-box",
                  height: "2px",
                  overflow: "visible",
                  flexShrink: 0,
                  borderWidth: "0px",
                  borderColor: "rgb(173, 255, 47)",
                  backgroundColor: "rgb(36, 43, 53)",
                  borderStyle: "none",
                  margin: "0px 16px",
                }}
              />
            </div>
            <ul
              style={{
                display: "flex",
                gap: "normal",
                boxSizing: "border-box",
                gridTemplateColumns: "repeat(auto-fit, minmax(7.75rem, 1fr))",
                maxWidth: "320px",
                width: "100%",
                listStyle: "outside none none",
                margin: "16px 0px 0px",
                padding: "0px",
              }}
            >
              <li
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  WebkitBoxPack: "center",
                  justifyContent: "center",
                }}
              >
                <a
                  href="https://apps.apple.com/fr/app/id343889987"
                  target="_blank"
                  title="Télécharger dans l'app store - Nouvel Onglet"
                  rel="noopener noreferrer"
                  style={{
                    fontSize: "13px",
                    lineHeight: "18px",
                    boxSizing: "border-box",
                    backgroundColor: "rgb(36, 43, 53)",
                    margin: "0px",
                    fontFamily: "Avenir",
                    fontWeight: 700,
                    textDecoration: "none solid rgb(255, 255, 255)",
                    cursor: "pointer",
                    position: "relative",
                    display: "flex",
                    WebkitBoxAlign: "center",
                    alignItems: "center",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    borderColor: "rgb(36, 43, 53)",
                    borderRadius: "24px",
                    color: "rgb(255, 255, 255)",
                    padding: "0px",
                    width: "100%",
                    maxWidth: "156px",
                    minHeight: "48px",
                    minWidth: "124px",
                  }}
                >
                  <img
                    src="https://www.sncf-connect.com/assets/media/pushstore/fr/store-apple.svg"
                    alt="Télécharger dans l'app store"
                    style={{
                      boxSizing: "border-box",
                      borderStyle: "none",
                      height: "48px",
                    }}
                  />
                </a>
              </li>
              <li
                style={{
                  marginLeft: "16px",
                  boxSizing: "border-box",
                  display: "flex",
                  WebkitBoxPack: "center",
                  justifyContent: "center",
                }}
              >
                <a
                  href="https://play.google.com/store/apps/details?id=com.vsct.vsc.mobile.horaireetresa.android&amp;hl=fr"
                  target="_blank"
                  title="Disponible sur google play - Nouvel Onglet"
                  rel="noopener noreferrer"
                  style={{
                    fontSize: "13px",
                    lineHeight: "18px",
                    boxSizing: "border-box",
                    backgroundColor: "rgb(36, 43, 53)",
                    margin: "0px",
                    fontFamily: "Avenir",
                    fontWeight: 700,
                    textDecoration: "none solid rgb(255, 255, 255)",
                    cursor: "pointer",
                    position: "relative",
                    display: "flex",
                    WebkitBoxAlign: "center",
                    alignItems: "center",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    borderColor: "rgb(36, 43, 53)",
                    borderRadius: "24px",
                    color: "rgb(255, 255, 255)",
                    padding: "0px",
                    width: "100%",
                    maxWidth: "156px",
                    minHeight: "48px",
                    minWidth: "124px",
                  }}
                >
                  <img
                    src="https://www.sncf-connect.com/assets/media/pushstore/fr/store-google.svg"
                    alt="Disponible sur google play"
                    style={{
                      boxSizing: "border-box",
                      borderStyle: "none",
                      height: "48px",
                    }}
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
